import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import Image from '../global/Image';

export default class PageTextCarousel extends Component {
    
    constructor(){
		super()
		this.state = {
			open:false,
		}
		this.handleToggle = this.handleToggle.bind(this);
	}
    
    handleToggle(_el) {  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    	setTimeout(() => {
				window.dispatchEvent(new Event('resize'));
			}, 800);
	    } else {
		    this.setState({ open : true });
		    setTimeout(() => {
				window.dispatchEvent(new Event('resize'));
			}, 800);
	    }
    }
    
	render () {
		
		let block 	= this.props.block;
		
		if (block.news) {
						
		    return (
		        
		        <div className="c-news">
					    	
		    		<div className="c-news__inner">
		    		
			    		<div className="l-grid">
			    		
			    			<div className="l-grid__col">
			    			
			    				<header className="c-news__header">
			    				
			    					<h1 className="c-heading c-heading--reverse">
										<span className="c-heading__line">
											<span className="c-heading__line__inner" dangerouslySetInnerHTML={{__html:'News & Media'}}></span>
										</span>
									</h1>
									
									
								</header>
								
								<div className="c-news__line c-load-fade"></div>
								
												
								<div className="c-news__thumbs">
									
									{block.news.map((news,i) =>
										{
											return (
												<div className="c-news__thumbs__thumb" key={i}>
													<a href={news.slug} className="c-news__thumbs__thumb__block" target="_blank">
														<div className="c-news__thumbs__thumb__image">
															<Image src={news.src} srcset={news.srcset}></Image>
															<div className="c-news__thumbs__thumb__overlay"></div>
															
														</div>
														<div className="c-news__thumbs__text">
															<h3 className="c-news__thumbs__thumb__heading" dangerouslySetInnerHTML={{__html:news.title }}></h3>
															<h4 className="c-news__thumbs__thumb__text" dangerouslySetInnerHTML={{__html:news.date + ' - LinkedIn'}}></h4>
														</div>
													</a>
												</div>
											)
										}
									)}
									
								</div>
								
							</div>
				    	
				    	</div>
				    	
				    </div>
				    
				</div>
    	
			        	
			)
			
		} else {
			
			return null;
		
		}
	}
}
